import React from 'react';
import config from '../../../../config';
import { Button, Col, FormControl, Row } from 'react-bootstrap';

export const LocationScanningScreen = (props) => {
  const { LocationInWarehouse = '' } = props.screensData;
  const imageURL = `${
    config.getEnvironmentName() == 'local' ? 'http://localhost:3037' : ''
  }/theme/assets/put_away_area.png`;
  return (
    <Row data-testid="screen-content" className="screen-content">
      <Col xs={6} className=" align-center text-center">
        <div className="green font-size-27 text-bold   bot20  ">Listing Complete!</div>
        <div className="font-size-22 purple">Please scan the item into Put Away area 1</div>
        <img className=" top30 bot30" src={imageURL} />
        <div className="top30 set-width" style={{ margin: '0 auto' }}>
          <FormControl
            data-testid="add-location-textarea"
            value={LocationInWarehouse}
            componentClass="textarea"
            ref={(warehouseLocationInput) => {
              props.setWarehouseLocationInput(warehouseLocationInput);
            }}
            placeholder=""
            onKeyPress={(e) => {
              props.setScreensData({ LocationInWarehouseTyped: true });
            }}
            onChange={({ target: { value } }) => {
              onTextChange(LocationInWarehouse, value, props);
            }}
            type="text"
          />
        </div>
      </Col>
      <div className="top30    text-center">
        <Button
          data-testid="next-screen-button"
          disabled={!LocationInWarehouse || props.pending}
          className="btn btn-lg btn-primary set-width "
          onClick={() => {
            onSubmitHandler(props);
          }}
        >
          Add Location
        </Button>
      </div>
    </Row>
  );
};

function onSubmitHandler(props) {
  if (props.pending) {
    return;
  }

  props.updateParentComponentState({ pending: false });
  props.setScreensData({ LocationInWarehouseTyped: false });
  props.submitHandler();
}

function onTextChange(locationInWarehouse, value, props) {
  let dataToUpdate = { LocationInWarehouse: value };
  let { LocationInWarehouseTyped = false } = props.screensData;

  if (locationInWarehouse.length > value.length) {
    /* when data is removed onKeyPress is not triggered */
    dataToUpdate.LocationInWarehouseTyped = LocationInWarehouseTyped = true;
  }

  if (value.toLowerCase().includes('box')) {
    return props.displayMessage({
      messageType: 'warning',
      messageCode: 'Sorry, locations with "box" word can be used only in the app',
    });
  }

  props.setScreensData(dataToUpdate, () => {
    setTimeout(() => {
      const { LocationInWarehouseTyped = false } = props.screensData;

      if (value == '') {
        props.setScreensData({ LocationInWarehouseTyped: false });
      } else if (!LocationInWarehouseTyped) {
        props.submitHandler();
      }
    }, 200);
  });
}
